// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginContainer .login {
  padding-bottom: 52px;
  text-align: center;
  margin: 0;
}
@media only screen and (min-width: 320px) and (max-width: 719px) {
  .loginContainer .login .logo {
    margin: 5% auto 0 auto;
  }
}
.loginContainer .login .imgWrapper {
  height: 79px;
}
.loginContainer .loginForm {
  position: relative;
  margin: 0 auto;
  width: 300px;
}
.loginContainer .loginForm .recaptcha {
  position: relative;
  margin: 30px auto 0px;
  width: 100%;
  float: none;
  padding: 0px;
}
.loginContainer .loginForm label {
  display: block;
  position: relative;
  margin-top: 10px;
  font-weight: bold;
  margin: 17px auto 5px auto;
  width: 288px;
  height: 16px;
  font-size: 14px;
  letter-spacing: -0.1px;
  text-align: left;
  color: #262626;
  opacity: 0.65;
}
@media only screen and (min-width: 320px) and (max-width: 719px) {
  .loginContainer .loginForm .primaryBtn {
    margin: 8% auto 5% auto;
  }
}
.loginContainer .loginForm input {
  display: block;
  margin: 0 auto 0 auto;
  padding-left: 10px;
  border: 1px solid #c3cad4;
  width: 288px;
  height: 36px;
  border-radius: 8px;
  background-color: #f8f7f3;
}
.loginContainer .loginForm .errorMessage {
  margin: 10px auto 0 auto;
  width: 297px;
  height: 40px;
  text-align: left;
  padding-left: 10px;
}
.loginContainer .loginForm .errorMessage p {
  display: inline-block;
  padding-left: 7px;
  height: 17px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  color: #f03;
}
.loginContainer .selectCustomer {
  display: block;
  margin: 0 auto 25px auto;
  width: 430px;
  height: 48px;
  font-size: 21px;
  font-weight: 900;
  letter-spacing: -0.1px;
  text-align: center;
  color: #061c3f;
}
.loginContainer .loginLabel {
  font-size: 21px;
  font-weight: 900;
  letter-spacing: -0.1px;
  text-align: center;
  color: #061c3f;
}
.loginContainer .primaryBtn {
  display: block;
  margin: 35px auto 20px auto;
  width: 95px;
  padding: 12px 0;
  font-weight: bold;
  border-radius: 30px;
  background-color: #19419b;
  border: none;
  font-size: 15px;
  color: #fff;
}
@media only screen and (min-width: 320px) and (max-width: 719px) {
  .loginContainer .selectCustomer {
    margin: 0 auto;
    width: 290px;
    font-size: 14px;
  }
}
.loginContainer .loginLink {
  margin: 0 20px;
  width: 100px;
  height: 21px;
  font-size: 15px;
  color: #19419b;
  text-decoration: none;
  font-weight: bold;
}
@media (max-width: 599px) {
  .loginContainer .globalFooter {
    text-align: center;
    padding: 0;
    bottom: 14px;
  }
  .loginContainer .globalFooter p,
  .loginContainer .globalFooter .footerLinks {
    float: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/login/Login.less"],"names":[],"mappings":"AAKA;EAEE,oBAAA;EACA,kBAAA;EACA,SAAA;AALF;AAOE;EAAA;IAEE,sBAAA;EALF;AACF;AAJA;EAaG,YAAA;AANH;AAPA;EAkBE,kBAAA;EACA,cAAA;EACA,YAAA;AARF;AAZA;EAuBG,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AARH;AAnBA;EA+BG,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AATH;AAYE;EAAA;IAEE,uBAAA;EAVF;AACF;AAtCA;EAoDG,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAXH;AAhDA;EA+DG,wBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAZH;AAvDA;EAsEI,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,0CAAA;EACA,eAAA;EACA,WAAA;AAZJ;AA/DA;EAiFE,cAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAfF;AA1EA;EA6FE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAhBF;AAjFA;EAqGE,cAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAjBF;AAoBC;EAAA;IAEE,cAAA;IACA,YAAA;IACA,eAAA;EAlBD;AACF;AApGA;EA0HE,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AAnBF;AAuBA;EACC;IACC,kBAAA;IACA,UAAA;IACA,YAAA;EArBA;EAkBD;;IAOE,WAAA;EArBD;AACF","sourcesContent":["@import (reference) '../../constants.less';\n\n@mobile: ~'only screen and (min-width: 320px) and (max-width: 719px)';\n@inputWidth: 288px;\n\n.loginContainer {\n\t.login {\n\t\tpadding-bottom: @globalFooterHeight;\n\t\ttext-align: center;\n\t\tmargin: 0;\n\n\t\t@media @mobile {\n\t\t\t.logo {\n\t\t\t\tmargin: 5% auto 0 auto;\n\t\t\t}\n\t\t}\n\n\t\t.imgWrapper {\n\t\t\theight: @loginImageWrapperHeight;\n\t\t}\n\t}\n\n\t.loginForm {\n\t\tposition: relative;\n\t\tmargin: 0 auto;\n\t\twidth: 300px;\n\n\t\t.recaptcha {\n\t\t\tposition: relative;\n\t\t\tmargin: 30px auto 0px;\n\t\t\twidth: 100%;\n\t\t\tfloat: none;\n\t\t\tpadding: 0px;\n\t\t}\n\n\t\tlabel {\n\t\t\tdisplay: block;\n\t\t\tposition: relative;\n\t\t\tmargin-top: 10px;\n\t\t\tfont-weight: bold;\n\t\t\tmargin: 17px auto 5px auto;\n\t\t\twidth: @inputWidth;\n\t\t\theight: 16px;\n\t\t\tfont-size: 14px;\n\t\t\tletter-spacing: -0.1px;\n\t\t\ttext-align: left;\n\t\t\tcolor: @labelGrey;\n\t\t\topacity: 0.65;\n\t\t}\n\n\t\t@media @mobile {\n\t\t\t.primaryBtn {\n\t\t\t\tmargin: 8% auto 5% auto;\n\t\t\t}\n\t\t}\n\n\t\tinput {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0 auto 0 auto;\n\t\t\tpadding-left: 10px;\n\t\t\tborder: 1px solid #c3cad4;\n\t\t\twidth: @inputWidth;\n\t\t\theight: 36px;\n\t\t\tborder-radius: 8px;\n\t\t\tbackground-color: @fieldBackgroundWhite;\n\t\t}\n\n\t\t.errorMessage {\n\t\t\tmargin: 10px auto 0 auto;\n\t\t\twidth: 297px;\n\t\t\theight: 40px;\n\t\t\ttext-align: left;\n\t\t\tpadding-left: 10px;\n\n\t\t\tp {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tpadding-left: 7px;\n\t\t\t\theight: 17px;\n\t\t\t\tfont-family: 'Source Sans Pro', sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: #f03;\n\t\t\t}\n\t\t}\n\t}\n\n\t.selectCustomer {\n\t\tdisplay: block;\n\t\tmargin: 0 auto 25px auto;\n\t\twidth: 430px;\n\t\theight: 48px;\n\t\tfont-size: 21px;\n\t\tfont-weight: 900;\n\t\tletter-spacing: -0.1px;\n\t\ttext-align: center;\n\t\tcolor: @nightBlue;\n\t}\n\n\t.loginLabel {\n\t\tfont-size: 21px;\n\t\tfont-weight: 900;\n\t\tletter-spacing: -0.1px;\n\t\ttext-align: center;\n\t\tcolor: #061c3f;\n\t}\n\n\t.primaryBtn {\n\t\tdisplay: block;\n\t\tmargin: 35px auto 20px auto;\n\t\twidth: 95px;\n\t\tpadding: 12px 0;\n\t\tfont-weight: bold;\n\t\tborder-radius: 30px;\n\t\tbackground-color: @buttonColor;\n\t\tborder: none;\n\t\tfont-size: 15px;\n\t\tcolor: #fff;\n\t}\n\n\t@media @mobile {\n\t\t.selectCustomer {\n\t\t\tmargin: 0 auto;\n\t\t\twidth: 290px;\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n\n\t.loginLink {\n\t\tmargin: 0 20px;\n\t\twidth: 100px;\n\t\theight: 21px;\n\t\tfont-size: 15px;\n\t\tcolor: @linkBlue;\n\t\ttext-decoration: none;\n\t\tfont-weight: bold;\n\t}\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t.loginContainer .globalFooter {\n\t\ttext-align: center;\n\t\tpadding: 0;\n\t\tbottom: 14px;\n\n\t\tp,\n\t\t.footerLinks {\n\t\t\tfloat: none;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
